// eslint-disable-next-line @typescript-eslint/naming-convention
export enum AUTH_STATUS {
  LOADING = 'loading',
  AUTHENTICATED = 'authenticated',
  NOT_AUTHENTICATED = 'not-authenticated'
}
